<template>
  <el-container direction="vertical" style="height: auto" id="orderDetails">
    <el-row class="row-bg">
      <!-- 头部 -->
      <el-header>
        <el-col :span="24" style="text-align: center">
          <div>
            <span class="p-title">{{dataInfo.sellProductName}}</span>
          </div>
        </el-col>
      </el-header>
    </el-row>
    <el-main>
      <!-- 表单计划 -->
      <el-row>
        <el-col :span="16" :push="4">
          <el-card class="box-card">
            <el-form label-width="155px" style="text-align: left;">
              <div class="box-card-div-title userInfo"><div class="header">基础信息</div></div>
              <el-form-item class="form-item-label" label="方案名称">
                <div>{{dataInfo.planName}}</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="订单号码">
                <div>{{dataInfo.orderIdNum}}</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="保险期限">
                <div>自 {{dataInfo.effectiveDate}} 起至 {{dataInfo.expireDate}} 止</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="订单状态">
                <div>{{dataInfo.orderStatusChinese}}</div>
              </el-form-item>
              <el-form-item v-if="specValue !== '0'" class="form-item-label" label="订单人数">
                <div>{{insureUser.length}}人</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="保费">
                <div>{{dataInfo.orderPayMoney}}元</div>
              </el-form-item>
            </el-form>
          </el-card>
          <el-card class="box-card">
            <el-form label-width="155px" style="text-align: left;">
              <div class="box-card-div-title userInfo"><div class="header">保障项目</div></div>
              <el-form-item v-for="(s,i) in sku" class="form-item-label" :key="i" :label="s.specName">
                <div>{{s.specValueName}}</div>
              </el-form-item>
              <el-form-item v-if="specValue !== '0'" class="form-item-label" label="附加险被保人数">
                <div>{{insureUser.length}}</div>
              </el-form-item>
              <el-table
                :data="insureEnsureList"
                :span-method="objectSpanMethod"
                border
                max-height="900"
                class="my-el-table"
                style="margin-left: 0;text-align: center">
                <el-table-column
                  prop="type"
                  label="险种"
                  width="300">
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="保障内容">
                </el-table-column>
                <el-table-column
                  prop="money"
                  width="100"
                  label="保额（元）">
                </el-table-column>
                <el-table-column
                  prop="detail"
                label="说明">
                </el-table-column>
              </el-table>
            </el-form>
          </el-card>
          <el-card class="box-card">
            <el-form label-width="155px" style="text-align: left;">
              <div class="box-card-div-title supportPlan"><div class="header">投保人信息</div></div>
              <el-form-item class="form-item-label" label="投保单位">
                <div>{{policyHolder.companyName}}</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="具体地址">
                <div>{{policyHolder.companyAddress}}</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="社会统一信用代码">
                <div>{{policyHolder.cardNum}}</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="联系人姓名">
                <div>{{policyHolder.name}}</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="联系人手机号码">
                <div>{{policyHolder.mobile}}</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="联系人邮箱">
                <div>{{policyHolder.email}}</div>
              </el-form-item>
              <el-form-item class="form-item-label" label="联系人地址">
                <div>{{policyHolder.address}}</div>
              </el-form-item>
              <el-form-item v-if="$$.isValidObj(orderExtendAddress.restaurantType)" class="form-item-label" label="餐厅类型">
                <el-select v-model="orderExtendAddress.restaurantType" placeholder="请选择"
                           class="form-item-input my-input" style="width: 50%" :disabled="true">
                  <el-option label="西餐厅" value='01'></el-option>
                  <el-option label="中餐厅" value='02'></el-option>
                  <el-option label="快餐厅" value='03'></el-option>
                  <el-option label="火锅店" value='04'></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="$$.isValidObj(orderExtendAddress.buildingStructure)" class="form-item-label" label="建筑结构">
                <el-select v-model="orderExtendAddress.buildingStructure" placeholder="请选择"
                           class="form-item-input my-input" style="width: 50%" :disabled="true">
                  <el-option label="钢结构" value='01'></el-option>
                  <el-option label="钢筋混凝土" value='02'></el-option>
                  <el-option label="混合结构" value='03'></el-option>
                  <el-option label="砖木结构" value='04'></el-option>
                  <el-option label="其他结构" value='05'></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="$$.isValidObj(orderExtendAddress.area)" class="form-item-label" label="面积(㎡)">
                <div>{{orderExtendAddress.area}}</div>
              </el-form-item>
              <span v-if="$$.isValidObj(orderExtendAddress.targetList)">
                <el-form-item label="标的物类型" class="form-item-label">
                <el-select v-model="orderExtendAddress.targetList.itemTypeL" placeholder="请选择"
                           class="form-item-input my-input" style="width: 50%" :disabled="true">
                  <el-option label="纯建筑物" value='01'></el-option>
                  <el-option label="纯机器设备" value='02'></el-option>
                  <el-option label="包含建筑物、机器设备等的纯固定资产" value='03'></el-option>
                  <el-option label="纯流动资产" value='04'></el-option>
                  <el-option label="固定资产和流动资产均有" value='05'></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="设备清单" class="form-item-label">
                <div v-for="item in orderExtendAddress.targetList.list">设备名称: {{item.machineName}}；数量: {{item.number}}；保额: {{item.insuredAmount}}</div>
              </el-form-item>
              <el-form-item label="被保险机器设备所在地" class="form-item-label">
                <div>{{policyHolder.companyAddress}}</div>
              </el-form-item>
              </span>
            </el-form>
          </el-card>
          <el-card class="box-card">
            <el-form label-width="155px" style="text-align: left;">
              <div class="box-card-div-title supportPlan"><div class="header">被保人信息</div></div>
              <el-table
                :data="insureCompany"
                border
                max-height="500"
                style="width: 100%;">
                <el-table-column
                  prop="name"
                  label="被保信息">
                </el-table-column>
                <el-table-column
                  prop="insuType"
                  label="险种">
                </el-table-column>
                <el-table-column
                  prop="accode"
                  label="保单号"
                width="350">
                </el-table-column>
                <el-table-column
                  prop="insuMoney"
                  label="金额(元)"
                width="150">
                </el-table-column>
              </el-table>
              <div v-if="specValue !== '0'" style="padding-top: 50px">
                <el-table
                  :data="insureUser"
                  border
                  max-height="500"
                  style="width: 100%">
                  <el-table-column
                    type="index"
                    label="序号"
                    width="50">
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="姓名">
                  </el-table-column>
                  <el-table-column
                    prop="cardType"
                    label="证件类型">
                  </el-table-column>
                  <el-table-column
                    prop="cardNum"
                    label="证件号码">
                  </el-table-column>
                  <el-table-column
                    prop="sex"
                    label="性别">
                  </el-table-column>
                  <el-table-column
                    prop="birthday"
                    label="出生日期">
                  </el-table-column>
                  <el-table-column
                    prop="relationship"
                    label="职业名称">
                  </el-table-column>
                </el-table>
              </div>
            </el-form>
          </el-card>
          <el-card class="box-card" v-if="JSON.stringify(orderMailInvoiceInfo) != '{}'">
            <el-form label-width="155px" style="text-align: left;">
              <div class="box-card-div-title userInfo"><div class="header">发票信息</div></div>
              <el-form-item class="form-item-label" label="发票类型">
                <div>{{orderMailInvoiceInfo.receiptType == 2 ?"增值税普通发票(电子发票)" : allData.receiptType === 3 ? "增值税专用发票(纸质发票)" : "增值税普通发票(纸质发票)"}}</div>
              </el-form-item>
              <span>
                <el-form-item class="form-item-label" label="发票抬头">
                  <div>{{policyHolder.companyName}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="纳税人识别号">
                  <div>{{policyHolder.cardNum}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="收件人姓名">
                  <div>{{orderMailInvoiceInfo.rName}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="收件人手机号">
                  <div>{{orderMailInvoiceInfo.rPhone}}</div>
                </el-form-item>
                <el-form-item class="form-item-label" label="收件人邮箱">
                  <div>{{orderMailInvoiceInfo.rMail}}</div>
                </el-form-item>
              </span>
            </el-form>
          </el-card>
          <!--<el-card class="box-card" v-else>
            <el-form label-width="155px" style="text-align: left;">
              <div class="box-card-div-title userInfo"><div class="header">发票信息</div></div>
              <el-form-item class="form-item-label" label="发票类型">
                <div>无发票</div>
              </el-form-item>
            </el-form>
          </el-card>-->
          <el-card class="box-card">
            <el-form label-width="155px" style="text-align: left;">
              <div class="box-card-div-title supportPlan"><div class="header">受益人信息</div></div>
              <el-form-item class="form-item-label" label="受益人">
                <div>法定受益人</div>
              </el-form-item>
            </el-form>
          </el-card>
          <el-row style="margin-bottom: 50px;text-align: center" v-if="dataInfo.orderStatus == 1 || dataInfo.orderStatus == 0">
            <el-button type="danger" round style="width: 240px;height: 40px;background: #FF7052;border-radius: 12px;" @click="onPay">立刻支付</el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-main>
    <el-dialog
      title="提示"
      :visible.sync="paymentCbk"
      :show-close=false
      :close-on-click-modal=false
      :close-on-press-escape=false
      width="30%"
      center>
      <div style="font-size:18px;text-align: center">{{payMsg}}</div>
    </el-dialog>
  </el-container>
</template>

<script>
  export default {
    name: "siNoSafeOrderDetails",
    data(){
      return{
        payMsg : '订单处理中',
        paymentCbk: false,
        location:false,
        formInline:{
          orderToken:''
        },
        dataInfo:{},
        //被保人信息
        insuredUserInfo:[],
        // 附加险被保人数组
        insureUser:[],
        // 主险被保人公司主体
        insureCompany: [],
        //投保人信息
        policyHolder:{},
        //发票信息
        orderMailInvoiceInfo:{},
        orderExtendAddress: {},
        insureEnsureList: [],
        beShareToken : '',
        sku: [{
          specName:'',
          specValueName : '',
          specValue:''
        }],
        specValue: '',
        spanObj:{},
        chinaArea: this.chinaLifeAccidentDistrict.chinaAreaList(),
        /*// 面积
        area: '',
        // 餐厅类型
        restaurantType: '',
        // 建筑结构
        buildingStructure: ''*/
        Second: 1,             //设置初始倒计时
      }
    },
    methods:{
      getOrderDetails() {
        this.location = true;
        this.axios.post('/management/mobileInsuranceInfo/loadOrderDetail?orderToken='+this.formInline.orderToken.replace(/%20/g,'%2B').replace(/\+/g,'%2B') +'&beShareToken='+ this.beShareToken.replace(/%20/g,'%2B').replace(/\+/g,'%2B')).then((response) => {
          let {success, datas, msg} = response.data;
          if (success){
            const {insuredUserInfo, policyHolder, insureEnsure, beShareToken, orderMailInvoiceInfo, sku, orderExtendAddress, productId} = datas;

            this.dataInfo = datas;
            this.insuredUserInfo = insuredUserInfo;
            this.insureUser = [];
            this.insureCompany = [];
            this.insuredUserInfo.forEach(item => {
              if( this.$$.isValidObj(item.occId) ){
                this.insureUser.push(item);
              }else {
                if( productId === 100435 ) item.insuType = "平安餐饮业综合保险";
                if( productId === 100424 ) item.insuType = "华安餐饮业综合保险";
                if( item.insuMoney === 60 ){
                  item.insuType = "机器损坏险";
                }
                item.insuMoney = item.insuMoney+".00";
                this.insureCompany.push(item);
              }
            });
            this.sku = sku;
            this.sku.forEach(item => {
              if(item.type === 7) this.specValue = item.specValue;
            });
            this.policyHolder = policyHolder;
            if( this.specValue === '0' ){
              insureEnsure.forEach(item => {
                if( item.type.toString().indexOf("雇主责任") === -1 )
                  this.insureEnsureList.push(item);
              });
            }else{
              insureEnsure.forEach(item => {
                this.insureEnsureList.push(item);
              });
            }

            this.insureEnsureList.forEach(item => {
              if(this.$$.isValidObj(item.detail)) item.detail = item.detail.toString().replace(/[<p>/]/g,'');
            });
            this.spanObj = this.$$.dataMethod(this.insureEnsureList);
            this.beShareToken = beShareToken;
            if(this.$$.isValidObj(orderMailInvoiceInfo)){
              this.orderMailInvoiceInfo = datas.orderMailInvoiceInfo;
            }
            if(this.$$.isValidObj(orderExtendAddress)){
              this.orderExtendAddress = datas.orderExtendAddress;
              if( this.$$.isValidObj(orderExtendAddress.targetList) ){
                this.orderExtendAddress.targetList = JSON.parse(orderExtendAddress.targetList);
              }
            }
          }else {
            this.$message.error(response.data.msg);
          }
          this.location = false;
        });
      },
      /**
       * 立刻支付
       * @param row
       */
      onPay(){
        let loadingInstance = this.Loading.service({fullscreen: true});
        this.axios.post('/management/mobileInsuranceInfo/orderPaymentBefore?orderToken='+this.formInline.orderToken.replace(/%20/g,'%2B').replace(/\+/g,'%2B') +'&beShareToken='+ this.beShareToken.replace(/%20/g,'%2B').replace(/\+/g,'%2B')).then((response) => {
          let data = response.data;
          if(data.success == true){
            let params = {
              orderToken: data.datas.orderToken,
              beShareToken: data.datas.orderToken
            };
            this.axios.post('/management/mobileInsuranceInfo/bindSellBillAtCostHandler?orderToken=' + encodeURIComponent(decodeURIComponent(data.datas.orderToken))).then((response) => {
              const { success, msg, datas } = response.data;
              if(success && this.$$.isValidObj(datas)){
                const { payUrl } = datas;
                window.location.href = payUrl;
              }else{
                if("I0004" == msg){
                  this.$$.alert({message: "订单已经支付成功！", onOk: function () {
                      this.$router.push({name: 'siNoSafeOrderDetails',query: { orderToken: params.orderToken, beShareToken: params.beShareToken } });
                    }
                  });
                  return;
                }
                this.$message.error(msg);
              }
              this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                loadingInstance.close();
              });
            });
          }else{
            this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              loadingInstance.close();
            });
            this.$message({
              type: 'info',
              message: data.msg
            });
          }
        });
      },
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        //列合并
        let _row = this.spanObj[column.property]?this.spanObj[column.property][rowIndex]:1;
        let _col = _row>0?1:0;
        return {
          rowspan: _row,
          colspan: _col
        }
      },
      // 支付状态校验轮询/management/mobileOrderInfoLog/getOrderStatus
      payCheck(){
        const that_ = this;
        this.axios.post('/management/mobileOrderInfoLog/getOrderStatus?orderToken='+this.formInline.orderToken.replace(/%20/g,'%2B').replace(/\+/g,'%2B') +'&shareToken='+ this.beShareToken.replace(/%20/g,'%2B').replace(/\+/g,'%2B')).then((response) => {
          let data = response.data;
          if(data.success === true){
            if(data.datas.orderStatus === 2){
              this.payMsg = '支付成功';
              const that = this;
              const interval = window.setInterval(function () {
                --that.Second;
                if (that.Second === 0) {
                  that.paymentCbk = false;
                  that_.getOrderDetails();
                  window.clearInterval(interval);
                }
              }, 1000);
              clearInterval(that.intervalwx);
              that.intervalwx = null;
            }
          }
        });
      }
    },
    mounted() {
      this.formInline.orderToken = this.$route.query.orderToken,this.formInline.orderToken = encodeURIComponent(decodeURIComponent(this.formInline.orderToken));
      this.beShareToken = this.$route.query.beShareToken,this.beShareToken = encodeURIComponent(decodeURIComponent(this.beShareToken));
      let that = this;
      if( this.$$.isValidObj(this.$route.query.paymentCbk) ){
        this.paymentCbk = this.$route.query.paymentCbk;
        that.intervalwx = window.setInterval(() => {
          setTimeout(this.payCheck(), 0)
        }, 2000);
      }else {
        this.getOrderDetails();
      }
    }
  }
</script>

<style scoped>
  .box-card {
    width: auto;
    height: auto;
    padding: 20px;
    margin-bottom: 2.5rem;
  }
  .box-card-div-title.userInfo {
    width: 96px;
  }
  .box-card-div-title.supportPlan{
    width: 120px;
  }

  .box-card-div-title {
    height: 12px;
    background: #FFBF00;
    font-size: 24px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 20px;
    display: inline-block;
    position: relative;
  }
  .p-title {
    font-size: 2.5rem;
    color: #333333;
    font-weight: bold;
    font-style: italic;
  }
  .p-present {
    font-size: 12px;
    font-weight: 500;
    font-style: italic;
    color: #666666;
  }
  .row-bg {
    padding: 60px 0 40px;
  }

  .form-item-label{
    font-size: 1rem;
    font-weight: 500;
    color: #333333;
    margin: 0 auto 5px;
  }
  .form-item-label div{
    width: 50%;
    font-size: 1rem;
    font-weight: 400;
    color: #333333;
    margin-left: 20px;
    border: 0 !important;
    background-color: #F7F7F7 !important;
    text-align: center !important;
  }

  .el-table th>.cell{
    text-align: center!important;
  }

  .box-card-div-title>.header{
    text-align: center;
    position: absolute;
    left: 0;
    top: -20px;
  }

  .el-table th{
    background: #EBEBEB!important;
  }

  /* 输入框去圆角 */
  .my-input /deep/ .el-input__inner {
    border: 0 !important;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: center !important;
  }

  .my-input-left /deep/ .el-input__inner {
    border: 0 !important;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: center !important;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/sinosafeInsurance/siNoSafeOrderDetails.vue